import * as React from 'react'
import Box from '@mui/material/Box'
import logo from '~/client/media/logo/datapal-logo-full-color-rgb-dark.svg'

export default function DataPalBanner(props){
  return <Box
    component="img"
    src={logo}
    {...props}
    sx={{
      display: 'block',
      m: 10,
      maxWidth: 'min(700px, 50vw)',
      mx: 'auto',
      ...props.sx
    }}
  />
}
